"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFragment = void 0;
exports.userFragment = `
  fragment user on User {
    id
    departmentId
    email
    firstName
    lastName
    ident
    mobilePhone
    employeeId
    timestamp
    employeeRoles {
      dealer {
        name
        dealerId
        code
      }
    }
  }
`;
//# sourceMappingURL=user.js.map